export default __webpack_public_path__ + "static/media/ocr_file_uploading.6907b90d.svg";